@if (!loginCheck) {
  <div class="login-container">
    <div class="login-card">
      <h4 class="text-center mb-4">Login</h4>
      <form [formGroup]="adminLoginForm" (ngSubmit)="loginClick()">
        <div class="mb-3">
          <label for="username" class="form-label">User name</label>
          <input type="text" class="form-control" id="username" placeholder="Enter your username" [(ngModel)]="loinEmail" formControlName="loginEmailId" required/>
          <div class="validation-errors mb-2">
            @for (validation of login_validation_messages.loginEmailId; track validation) {
              @if (adminLoginForm.get('loginEmailId')?.hasError(validation.type) && (adminLoginForm.get('loginEmailId')?.dirty || adminLoginForm.get('loginEmailId')?.touched)) {
                <div class="error-message">
                  {{ validation.message }}
                </div>
              }
            }
          </div>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" class="form-control" id="password" placeholder="Enter your password" [(ngModel)]="loginPwd" formControlName="loginPassword" required/>
          <div class="validation-errors mb-2">
            @for (validation of login_validation_messages.loginPassword; track validation) {
              @if (adminLoginForm.get('loginPassword')?.hasError(validation.type) && (adminLoginForm.get('loginPassword')?.dirty || adminLoginForm.get('loginPassword')?.touched)) {
                <div class="error-message">
                  {{ validation.message }}
                </div>
              }
            }
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-custom btn-warning" [disabled]="!adminLoginForm.valid">Login</button>
        </div>
      </form>
    </div>
  </div>
}
@if (loginCheck) {
  <div class="p-4">
    <div class="fs-3 pt-2 text-left fw-b mt-3 mb-4">Admin Dashboard / Report</div>
    @if (searchField == true) {
      <div class="row">
        <div class="col-3">
          <label for="select-filter-option" class="mb-2" style="font-weight: 500;">Search By</label>
          <select id="select-filter-option" class="form-select" [(ngModel)]="adminSearchData.searchByOptionVal" (change)="selectByFilter($event)">
            <option value="0">Select Option</option>
            <option value="email">Email ID</option>
            <option value="productType">Product Type</option>
            <option value="date">Date</option>
          </select>
        </div>
        @if (selectFilterOption == 'date') {
          <div class="col-3">
            <label for="date" class="mb-2" style="font-weight: 500;">From Date</label>
            <div class="date-container" style="position: relative;">
              <input id="fromDate" ngbDatepicker #d="ngbDatepicker" class="form-control date-in" name="frdp" placeholder="mm/dd/yyyy" [(ngModel)]="fromDateToSearch" [dayTemplate]="customDay" [maxDate]="maxDate" [navigation]="'select'">
              <div class="input-group-append date-btn-container">
                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button">📅</button>
              </div>
            </div>
          </div>
        }
        @if (selectFilterOption == 'date') {
          <div class="col-3">
            <label for="date" class="mb-2" style="font-weight: 500;">To Date</label>
            <div class="date-container" style="position: relative;">
              <input id="toDate" ngbDatepicker #d="ngbDatepicker" class="form-control date-in" name="todp" placeholder="mm/dd/yyyy" [(ngModel)]="toDateToSearch" [dayTemplate]="customDay" [maxDate]="maxDate" [min]="fromDateToSearch?fromDateToSearch:''"  [navigation]="'select'">
              <div class="input-group-append date-btn-container">
                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button">📅</button>
              </div>
            </div>
          </div>
        }
        @if (selectFilterOption == 'emailId') {
          <div class="col-3">
            <label for="email-id" class="mb-2" style="font-weight: 500;">Email ID</label>
            <input id="email-id" type="text" class="form-control" placeholder="Enter your email ID" [(ngModel)]="emailIdToSearch">
          </div>
        }
        @if (selectFilterOption == 'productType') {
          <div class="col-3">
            <label for="product-type" class="mb-2" style="font-weight: 500;">Product Type</label>
            <!-- <input id="product-type" type="text" class="form-control" placeholder="Enter the product type" [(ngModel)]="productTypeToSearch"> -->
            <select  id="product-type" class="form-control form-select" [(ngModel)]="productTypeToSearch"  (change)="productTypeClick($event.currentTarget)">
              <option  value="">Select Product Type</option>
              <option  value="Web PCB">Web PCB</option>
              <option  value="Product 1">Product 1</option>
              <option  value="Product 2">Product 2</option>
              <option  value="Custom/Advanced PCB">Custom/Advanced PCB</option>
            </select>
          </div>
        }
        <!-- <div class="col-3" *ngIf="selectFilterOption == 'quotePlaced'">
        <label for="quotePlaced" class="mb-2" style="font-weight: 500;">Quote Placed</label>
        <input id="quotePlaced" type="text" class="form-control" placeholder="Enter data" [(ngModel)]="quotePlacedToSearch">
      </div>
      <div class="col-3" *ngIf="selectFilterOption == 'orderPlaced'">
        <label for="orderPlaced" class="mb-2" style="font-weight: 500;">Order Placed</label>
        <input id="orderPlaced" type="text" class="form-control" placeholder="Enter data" [(ngModel)]="orderPlacedToSearch">
      </div> -->
      <div class="col-3">
        <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" style="margin-top: 2rem !important;" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="searchForData(1)">Search</button>
        <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" style="margin-top: 2rem !important;"data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="clearSearchData()">Clear</button>
      </div>
    </div>
  }
  <!-- OFP-1948 -->
  @if (summaryColData != '') {
    <div id="summary-table">
      <div class="bom-table" style="width:100% !important;" >
        <div class="mt-3 mb-3" id="admin-summery-table">
          <!--  datatable [dtOptions]="dtOptionsSummary" [dtTrigger]="dtTriggerSummary" -->
          <table id="dynamic-table" style="width:100%;" datatable [dtOptions]="dtOptionsSummary" [dtTrigger]="dtTriggerSummary">
            <thead class="table-primary">
              @if (isSummaryDataHasOlder) {
                <tr>
                  <th></th>
                  <th>{{this.summaryColData[0].label}}</th>
                  @for (col of filteredSummaryColData; track col; let i = $index) {
                    <th>{{col.dateValue}} <span><br></span>{{col.dayOfWeek}}</th>
                  }
                </tr>
              }
              @if (!isSummaryDataHasOlder) {
                <tr>
                  <th></th>
                  @for (col of summaryColLabels; track col; let i = $index) {
                    <th>{{col.dateValue}} <span><br></span>{{col.dayOfWeek}}</th>
                  }
                </tr>
              }
            </thead>
            @if (summaryRowData != '') {
              <tbody>
                <tr>
                  <td>File Uploads</td>
                  @for (row of summaryRowData.FILE_UPLOADS; track row; let j = $index) {
                    <td>@if (row > 0) {
                      <span (click)="onSummaryDataClick('File Uploads',row,j)" class="ofp-link">{{row}}</span>
                      }@if (row == 0) {
                      <span>{{row}}</span>
                    }</td>
                  }
                </tr>
                <tr>
                  <td>PCB Only Quoted</td>
                  @for (row of summaryRowData.PCB_ONLY_QUOTED; track row; let j = $index) {
                    <td>@if (row > 0) {
                      <span (click)="onSummaryDataClick('PCB Only Quoted',row,j)" class="ofp-link">{{row}}</span>
                      }@if (row == 0) {
                      <span>{{row}}</span>
                    }</td>
                  }
                </tr>
                <tr>
                  <td>PCB + Assembly Quoted</td>
                  @for (row of summaryRowData.PCB_ASSEMBLY_QUOTED; track row + '-' + $index; let j = $index) {
                    <td>@if (row > 0) {
                      <span (click)="onSummaryDataClick('PCB + Assembly Quoted',row,j)" class="ofp-link">{{row}}</span>
                      }@if (row == 0) {
                      <span>{{row}}</span>
                    }</td>
                  }
                </tr>
                <tr>
                  <td>Quote Saved</td>
                  @for (row of summaryRowData.QUOTE_SAVED; track row + '-' + $index; let j = $index) {
                    <td>@if (row > 0) {
                      <span (click)="onSummaryDataClick('Quote Saved',row,j)" class="ofp-link">{{row}}</span>
                      }@if (row == 0) {
                      <span>{{row}}</span>
                    }</td>
                  }
                </tr>
                <tr>
                  <td>Order Placed</td>
                  @for (row of summaryRowData.ORDER_PLACED; track row + '-' + $index; let j = $index) {
                    <td>@if (row > 0) {
                      <span (click)="onSummaryDataClick('Order Placed',row,j)" class="ofp-link">{{row}}</span>
                      }@if (row == 0) {
                      <span>{{row}}</span>
                    }</td>
                  }
                </tr>
                <tr>
                  <td>Custom Quote Request Placed</td>
                  @for (row of summaryRowData.CUSTOM_QUOTE_REQUESTED; track row + '-' + $index; let j = $index) {
                    <td>@if (row > 0) {
                      <span (click)="onSummaryDataClick('Custom Quote Request Placed',row,j)" class="ofp-link">{{row}}</span>
                      }@if (row == 0) {
                      <span>{{row}}</span>
                    }</td>
                  }
                </tr>
              </tbody>
            }
          </table>
        </div>
      </div>
    </div>
  }
  <div >
    <div>
      @if (showGrid) {
        <div class="d-flex justify-content-end mb-2">
          <button type="button" class="btn btn-warning" (click)="exportCsv()" style="font-size: 0.88em;font-weight: 600;">
            <!-- <i class="fa fa-download me-1"></i> -->
            Export to CSV
          </button>
        </div>
        <div class="ag-theme-quartz" style="height:600px;width:100%;">
          <ag-grid-angular  style="display:block;height:100%;width:100%;"
          [theme]="'legacy'"
              [rowData]="rowData"
              [getRowHeight]="getRowHeight"
              [columnDefs]="columnDefs"
              [pagination]="true"
              [paginationPageSize]="15"
              [paginationPageSizeSelector] = "[15, 20, 50, 100]"
              (gridReady)="onGridReady($event)"
              [headerHeight]="100"
              [groupHeaderHeight]="80"
               [enableCellTextSelection]="true"
              [defaultColDef]="defaultColDef">
          </ag-grid-angular>

        </div>
      }
</div>
<!-- <div class="pagination-container" *ngIf="paginatedItems != ''">
<span id="page-info">Page {{currentPage}} of {{totalPages}}</span>
<div id="pagination" class="pagination"></div>
</div> -->
</div>
</div>
}
<ng-template #listOfSpecification let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">List of PCB Specifications </h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
      <div class="fw-b">Extracted:</div>
      <ul style="padding-left: 2.5rem !important;">
        @for (eList of extractedList; track eList; let i = $index) {
          <li>{{eList.key}} : {{eList.value}}</li>
        }
      </ul>
      <div class="fw-b">Default:</div>
      <ul style="padding-left: 2.5rem !important;">
        @for (dList of defaultList; track dList; let j = $index) {
          <li>{{dList.key}} : {{dList.value}}</li>
        }
      </ul>
      @if (updatedList != '' && updatedList != undefined) {
        <div class="fw-b">Updated:</div>
      }
      @if (updatedList != '' && updatedList != undefined) {
        <ul style="padding-left: 2.5rem !important;">
          @for (uList of updatedList; track uList; let k = $index) {
            <li>{{uList.key}} : {{uList.value}}</li>
          }
        </ul>
      }
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-warning btn-min-wt" (click)="modal.close('cancel click')"><b>Ok</b></button>
  </div>
</ng-template>
<ng-template #customSpecification let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">List of PCB Specifications </h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
      <ul>
        @for (item of customParametersList | keyvalue; track item) {
          <li style="list-style-type: auto;padding-bottom: 2px">{{item.value}}</li>
        }
      </ul>
    </div>
  </div>
</ng-template>
<ng-template #uploadedFileIssues let-modal class="auto-mapping-modal" let-data="data">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">Uploaded File Issues </h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
      <ul style="word-wrap: break-word;">
        @for (item of issuesList; track item; let in = $index) {
          <div>
            @if (item.error) {
              <li>{{item.error}}</li>
            }
            @if (item.warning) {
              <li>{{item.warning}}</li>
            }
          </div>
        }
      </ul>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-warning btn-min-wt" (click)="modal.close('cancel click')"><b>Ok</b></button>
  </div>
</ng-template>
<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected">
  <span class="custom-day"
    [class.text-muted]="date.month !== currentMonth"
    [class.bg-primary]="selected"
    [class.today]="">
    {{ date.day }}
  </span>
</ng-template>
